export const SERVICE_WORKER_TYPES = {
  postAction: "POST_ACTION",
  networkStatus: "NETWORK_STATUS",

}
